{
  "app": {
    "create_view_label": "Vue d'entreprise",
    "read_only": "Lecture seule",
    "no_access_message": "Vous n'avez pas accès à ce projet. Veuillez demander à la personne qui a partagé le lien avec vous de vous ajouter en tant que membre de l'équipe.",
    "search_no_results": "Impossible de trouver une/des application(s) avec le titre \"{{term}}\"",
    "no_apps_message": "Il n'y a pas d'application pour vous, créez-en une maintenant",
    "view_table": "Tableau",
    "view_grid": "Grille",
    "get_started_message": "Pour commencer, ajoutez votre première liste à partir du bouton + ci-dessus à gauche.",
    "unknown_tab_type": "Type d'onglet inconnu",
    "table": {
      "app_header": "Application",
      "workspace_header": "Espace de travail",
      "team_members_header": "Membres de l'équipe"
    },
    "team_share": "Équipe/Partager",
    "team": "Équipe"
  },
  "opportunities": {
    "form": {
      "header": "Opportunité",
      "company_label": "Sélectionner l'entreprise associée *",
      "company_placeholder": "Tapez pour rechercher une entreprise",
      "status_label": "Statut",
      "description_label": "Description",
      "description_placeholder": "Décrivez votre opportunité en une phrase",
      "tags_label": "Étiquettes",
      "proposed_fee_label": "Frais proposés",
      "date_label": "Date de l'opportunité",
      "date_placeholder": "date",
      "internal_owner_label": "Propriétaire interne",
      "internal_owner_placeholder": "Qui sera responsable de cette opportunité?",
      "team_involved_label": "Équipe impliquée",
      "team_involved_placeholder": "Équipe impliquée dans cette opportunité?",
      "referral_source_label": "Source de référence",
      "referral_source_placeholder": "Qui a référé cette opportunité?"
    },
    "workspace": {
      "link_button": "Lier l'espace de travail",
      "link_modal_label": "Espaces de travail",
      "link_validation": "Veuillez sélectionner un espace de travail",
      "unlink_title": "dissocier l'opportunité de l'espace de travail",
      "unlink_confirmation": "Cliquez sur confirmer pour dissocier l'opportunité de l'espace de travail",
      "unlink_confirm_title": "Êtes-vous sûr de vouloir dissocier cette opportunité?",
      "actions": {
        "update": "Mettre à jour",
        "unlink": "Dissocier"
      },
      "custom_fields": {
        "section_header": "Colonnes de l'espace de travail"
      }
    },
    "actions": {
      "add_opportunity": "Ajouter une opportunité",
      "add_column": "Ajouter une colonne"
    }
  },
  "more_actions": {
    "manage_columns": "Gérer les colonnes"
  }
}
